<template>
  <div class="text--primary">
    <v-row dense>
      <v-col cols="12" sm="6">
        {{ aprovacao.identificador }}
        <px-requisicao-urgencia :urgencia="aprovacao.urgencia"/>
      </v-col>
      <v-col cols="12" sm="6" class="text-right">
        <v-btn color="success" small
               class="ml-1 normal-btn-text rounded-tag-small elevation-0">
          <v-icon small>mdi-check</v-icon>Aprovar
        </v-btn>
        <v-btn color="error" small
               class="ml-1 normal-btn-text rounded-tag-small elevation-0">
          <v-icon small>mdi-close</v-icon>Recusar
        </v-btn>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="9" class="text-truncate">
        <v-icon small>mdi-pound</v-icon>
        <span class="font-weight-bold">Código:</span>
        {{ aprovacao.id }}
      </v-col>
    </v-row>
    <v-row dense v-if="aprovacao.codigoInterno">
      <v-col cols="12" sm="9" class="text-truncate">
        <v-icon small>mdi-pound</v-icon>
        <span class="font-weight-bold">Código interno:</span>
        {{ aprovacao.codigoInterno }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">
          Local de faturamento <v-icon small>mdi-map-marker-check</v-icon>
        </span>
        <v-row dense>
          <v-col cols="12">
            {{ aprovacao.comprador.pessoa.nome }} ({{ aprovacao.comprador.pessoa.cnpj | cnpj }})
            <div class="">
              {{ aprovacao.comprador.endereco | endereco }}
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">
          Local de entrega <v-icon small>mdi-map-marker</v-icon>
        </span>
        <v-row dense>
          <v-col cols="12">
            {{ aprovacao.comprador.pessoa.nome }} ({{ aprovacao.comprador.pessoa.cnpj | cnpj }})
            <div class="">
              {{ aprovacao.comprador.endereco | endereco }}
            </div>
            <div class="mt-1" v-if="aprovacao.dataEntrega">
              <v-icon small left>mdi-calendar</v-icon>
              <span class="font-weight-bold">Entrega em </span>
              {{ aprovacao.dataEntrega | date }}
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Centro de custo</span>
        <div>
          {{ centroCusto | naoInformado }}
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Projeto</span>
        <div>
          {{ projeto | naoInformado }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Solicitante</span>
        <div>
          {{
            (aprovacao.usuario ?
              aprovacao.usuario.nome : aprovacao.nomeResponsavel) | naoInformado
          }}
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Finalidade da Compra</span>
        <div v-if="aprovacao.finalidadeCompra">
          <px-finalidade-compra-value :finalidade-compra="aprovacao.finalidadeCompra"/>
        </div>
        <div v-else>
          Não Informado
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">{{ labelCompradorResponsavel }}</span>
        <div>
          {{ compradoresResponsaveis }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Observações internas</span>
        <div>
          <px-show-large-text :large-text="aprovacao.observacaoInterna"/>
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Observações externas</span>
        <div>
          <px-show-large-text :large-text="aprovacao.observacaoExterna"/>
        </div>
      </v-col>
      <v-col cols="12" sm="6" v-if="aprovacao.arquivos && aprovacao.arquivos.length">
        <span class="caption font-weight-bold">Anexos</span>
        <px-anexo-chip :files="aprovacao.arquivos"
                       download-base-path="files/download-comprador"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ObjectUtils from '@/utils/object-utils';

export default {
  props: {
    aprovacao: {
      type: Object,
    },
  },
  computed: {
    centroCusto() {
      return this.aprovacao.centroCusto
        ? ObjectUtils.descWithCodigoInterno(this.aprovacao.centroCusto) : null;
    },
    projeto() {
      return this.aprovacao.projeto
        ? ObjectUtils.descWithCodigoInterno(this.aprovacao.projeto) : null;
    },
    compradoresResponsaveis() {
      if (!this.aprovacao.compradoresResponsaveis) {
        return null;
      }
      return this.aprovacao.compradoresResponsaveis
        .map(user => user.nome)
        .join(', ');
    },
    labelCompradorResponsavel() {
      return this.aprovacao.compradoresResponsaveis
      && this.aprovacao.compradoresResponsaveis.length > 1 ? 'Compradores responsáveis' : 'Comprador responsável';
    },
  },
  data() {
    return {
      loading: false,
    };
  },
};
</script>
